import React, { ReactNode } from "react";

import {
  DataRoomsActionsContext,
  ReportsActionsContext,
  TaskManageActionsContext,
  TaggerActionsContext,
  useGetActionsHook,
  AuthActionsContext,
  CommentsActionsContext,
  DealActionsContext,
  UserActionsContext,
  ViewActionsContext,
  useDispatch,
  useStore,
  UserManageActionsContext,
  DocumentsActionsContext,
  PortfolioConstructionActionsContext,
  DebtActionsContext,
  EntityTagActionsContext,
  NewsFeedActionsContext,
  BulkUploadActionsContext
} from "store";
import { useApi } from "../Api-provider/ApiContext";

interface IStoreProviderProps {
  children: ReactNode;
}

export const ActionsProvider = ({ children }: IStoreProviderProps): JSX.Element => {
  const state = useStore();
  const dispatch = useDispatch();
  const apiContext = useApi();
  const actions = useGetActionsHook({ state, dispatch, apiContext });

  return (
    <AuthActionsContext.Provider value={actions.authActions}>
      <UserActionsContext.Provider value={actions.userActions}>
        <DealActionsContext.Provider value={actions.dealActions}>
          <CommentsActionsContext.Provider value={actions.commentsActions}>
            <ViewActionsContext.Provider value={actions.viewActions}>
              <ReportsActionsContext.Provider value={actions.reportsActions}>
                <DebtActionsContext.Provider value={actions.debtActions}>
                  <DataRoomsActionsContext.Provider value={actions.dataRoomsActions}>
                    <TaggerActionsContext.Provider value={actions.taggerActions}>
                      <TaskManageActionsContext.Provider value={actions.taskManageActions}>
                        <UserManageActionsContext.Provider value={actions.userManageActions}>
                          <DocumentsActionsContext.Provider value={actions.documentsActions}>
                            <PortfolioConstructionActionsContext.Provider value={actions.portfolioConstructionActions}>
                              <EntityTagActionsContext.Provider value={actions.entityTagActions}>
                                <NewsFeedActionsContext.Provider value={actions.newsFeedActions}>
                                  <BulkUploadActionsContext.Provider value={actions.bulkUploadActions}>
                                    {children}
                                  </BulkUploadActionsContext.Provider>
                                </NewsFeedActionsContext.Provider>
                              </EntityTagActionsContext.Provider>
                            </PortfolioConstructionActionsContext.Provider>
                          </DocumentsActionsContext.Provider>
                        </UserManageActionsContext.Provider>
                      </TaskManageActionsContext.Provider>
                    </TaggerActionsContext.Provider>
                  </DataRoomsActionsContext.Provider>
                </DebtActionsContext.Provider>
              </ReportsActionsContext.Provider>
            </ViewActionsContext.Provider>
          </CommentsActionsContext.Provider>
        </DealActionsContext.Provider>
      </UserActionsContext.Provider>
    </AuthActionsContext.Provider>
  );
};

ActionsProvider.displayName = "ActionsProvider";
